__turbopack_context__.v({
  "component": "style-module-scss-module__KsZitq__component",
  "content": "style-module-scss-module__KsZitq__content",
  "dropdown": "style-module-scss-module__KsZitq__dropdown",
  "icon": "style-module-scss-module__KsZitq__icon",
  "iconOnly": "style-module-scss-module__KsZitq__iconOnly",
  "localeCode": "style-module-scss-module__KsZitq__localeCode",
  "rail": "style-module-scss-module__KsZitq__rail",
  "railDropdown": "style-module-scss-module__KsZitq__railDropdown",
  "railLabel": "style-module-scss-module__KsZitq__railLabel",
  "railWrap": "style-module-scss-module__KsZitq__railWrap",
});
